import { useCreditCard } from "@/hooks/useCreditCard";
import { LogoBarteCreditCard } from "@/styles/icons/LogoBarteCreditCard";
import { Box, Flex, Text, Badge, SkeletonText } from "@chakra-ui/react";
import { Tooltip } from "barte-design-system";
interface CreditCardProps {
  cardNumber?: string;
  holderName?: string;
  type?: string;
}

export function CreditCard({
  cardNumber = "",
  holderName = "",
  type = "",
}: CreditCardProps) {
  const maskCardNumber = (number: string) => {
    const last4Digits = number.slice(-4);
    const maskedPart = "• • • •   • • • •   • • • •   ";
    return maskedPart + last4Digits;
  };
  const maskCvv = () => "• • •";
  const maskExpiryDate = () => "••/••";
  const { creditCardLoading } = useCreditCard();
  return (
    <Box
        w="300px"
        h="185px"
        rounded="20px"
        p="6" 
        bgImage={`url("/images/commons/barte-credit-card-background.png")`}
        bgSize="cover"
        color="white"
        shadow="xl"
    >
      <Flex justify="space-between" align="start">
        <LogoBarteCreditCard />
        <Badge
            fontSize="sm"
            px="3"
            py="1"
            rounded="full"
            bg="whiteAlpha.200"
            color="white"
        >
            {type}
        </Badge>
      </Flex>
      <Box mt="8" mb="8">
        <SkeletonText 
          isLoaded={!creditCardLoading} 
          noOfLines={1} 
          skeletonHeight="4" 
          borderRadius="1rem"
        >
          <Text 
              fontSize={["0.6rem", "0.8rem", "1rem"]} 
              letterSpacing="widest"
          >
            {maskCardNumber(cardNumber)}
          </Text>
        </SkeletonText>
      </Box>
      <Flex 
        justify="space-between" 
        align="end"
      >
        <Box>
            <Text 
                fontSize={["6px", "8px", "10px"]}
                opacity="0.7" 
            >
                {maskExpiryDate()}
            </Text>
            <Tooltip 
              label={holderName} 
              placement="top"
            >
              <Text 
                  maxW="212px"
                  fontWeight="light"
                  isTruncated
                  fontSize={["0.6rem", "0.8rem", "1rem"]}
              >
                  {holderName}
              </Text>
            </Tooltip>
        </Box>
        <Box>
          <Text 
            fontSize={["6px", "8px", "10px"]}
            opacity="0.7" 
          >
            CVV
          </Text>
          <Text>{maskCvv()}</Text>
        </Box>
      </Flex>
    </Box>
  );
}